export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-dislike-072f675fe117097aac51309f8f89821b.svg";